import React from 'react';
import { Utensils, Dumbbell, Calendar, Clock, CheckCircle2 } from 'lucide-react';
export function MechanismSection() {
  const mechanisms = [{
    icon: Utensils,
    title: 'Food Anchors',
    subtitle: 'Minimums, Not Perfection',
    description: "So cravings don’t turn into an all-night negotiation. You’ll stop asking: 'What should I eat?' and start using: 'When I’m tired, I eat this.'"
  }, {
    icon: Dumbbell,
    title: 'Training Swaps',
    subtitle: 'Green / Yellow / Red Day Rules',
    description: 'So you don’t disappear just because intensity feels awful. You’ll always have a workout that matches your energy and still counts.'
  }, {
    icon: Calendar,
    title: 'Calendar Protections',
    subtitle: 'Pre-Decisions + Scripts',
    description: 'Stop bleeding energy into overbooked evenings. You’ll get copy/paste scripts for work, social, and relationship boundaries.'
  }, {
    icon: Clock,
    title: '10-Minute Luteal Rescue',
    subtitle: 'The Core Protocol',
    description: 'The moment you feel the slide start, use this 10-minute sequence to stabilize fast. Blood sugar anchor + nervous system downshift.',
    highlight: true
  }];
  return <section className="py-20 px-4 sm:px-6 bg-[#4A2C40] text-[#FDFBF7]" data-id="element-55">
      <div className="max-w-7xl mx-auto" data-id="element-56">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-57">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-58">
            The Phase-Proof Plan
          </h2>
          <p className="text-xl text-[#FDFBF7]/80" data-id="element-59">
            A 4-part system that changes on purpose by phase. Build a routine
            that is hard to break.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-60">
          {mechanisms.map((item, index) => <div key={index} className={`p-8 rounded-2xl transition-all duration-300 ${item.highlight ? 'bg-[#F3EFE7] text-[#4A2C40] ring-4 ring-[#F3EFE7]/30' : 'bg-[#5D3A52] text-[#FDFBF7] hover:bg-[#66405A]'}`} data-id="element-61">
              <div className={`inline-flex items-center justify-center p-3 rounded-xl mb-6 ${item.highlight ? 'bg-[#4A2C40] text-[#FDFBF7]' : 'bg-[#4A2C40]/30 text-[#FDFBF7]'}`} data-id="element-62">
                <item.icon className="h-8 w-8" data-id="element-63" />
              </div>

              <h3 className="text-2xl font-serif font-bold mb-2" data-id="element-64">
                {index + 1}. {item.title}
              </h3>
              <p className={`text-sm font-bold uppercase tracking-wider mb-4 ${item.highlight ? 'text-[#4A2C40]/70' : 'text-[#FDFBF7]/60'}`} data-id="element-65">
                {item.subtitle}
              </p>
              <p className={`text-lg leading-relaxed ${item.highlight ? 'text-[#4A2C40]/90' : 'text-[#FDFBF7]/90'}`} data-id="element-66">
                {item.description}
              </p>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-67">
          <div className="inline-flex items-center gap-2 text-[#F3EFE7] bg-[#4A2C40] px-6 py-3 rounded-full border border-[#F3EFE7]/20" data-id="element-68">
            <CheckCircle2 className="h-5 w-5" data-id="element-69" />
            <span className="font-medium" data-id="element-70">Not willpower. Defaults.</span>
          </div>
        </div>
      </div>
    </section>;
}